import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bd22d66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-top":"32px"} }
const _hoisted_2 = { class: "setting-content-box-subtitle row ibf-h5" }
const _hoisted_3 = { class: "description-text" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Optional")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gordita-400-11 ib-color-red" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "uis uis-exclamation-circle",
    style: {"font-size":"16px"}
  }),
  /*#__PURE__*/_createElementVNode("span", {
    style: {"margin":"0 4px","line-height":"14px"},
    class: "message-text"
  }, "Invalid format")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip_btn = _resolveComponent("tooltip-btn")!
  const _component_incredi_text_input = _resolveComponent("incredi-text-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.general.network.agentCertificateValidation.title')), 1),
      _createVNode(_component_tooltip_btn, {
        "tooltip-width": 300,
        "btn-icon": "icon-question-circle",
        style: {"margin-left":"7px"},
        "tooltip-title": _ctx.$t('settings.general.network.agentCertificateValidation.tooltip')
      }, null, 8, ["tooltip-title"]),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('settings.general.network.agentCertificateValidation.description')), 1),
      _createVNode(_component_incredi_text_input, {
        disable: _ctx.disable,
        "to-be-clearable": false,
        outlined: "",
        standout: "",
        counter: "",
        "model-value": _ctx.modelValue?.settings?.windows?.coordinator?.sslCNValidationPattern || '',
        error: _ctx.validationTriggered,
        class: "certificate-input",
        "no-error-icon": "",
        type: "textarea",
        "bottom-slots": "",
        maxlength: "1000",
        placeholder: "Enter Regex",
        "input-class": "gordita-400-12",
        onKeydown: _cache[0] || (_cache[0] = ($event: any) => (_ctx.validationTriggered = false)),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = 
          (val) => {
            _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.coordinator.sslCNValidationPattern, val);
            _ctx.isRegExpValid(val);
          }
        )
      }, {
        hint: _withCtx(() => [
          _hoisted_4
        ]),
        error: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["disable", "model-value", "error"])
    ])
  ]))
}